import React, { useMemo, useState } from 'react';
import { Field, Form } from 'react-final-form';

import Button from '../../shared/Button';
import Checkbox from '../../shared/Checkbox';
import Input from '../../shared/Input';
import DatePicker from '../../shared/date-picker/DatePicker';

import { countTypes } from '../../../constants/enums';

import '../../../styles/shared/form.scss';

const Step2 = (props) => {
  const {
    onClickNext = () => {},
    loading,
    onClickBack,
    initialValues = {},
    kits = [],
    type,
    sets = [],
  } = props;

  const { hospitalId } = initialValues;

  const [search, setSearch] = useState('');

  const validate = (values) => {
    const errors = {};

    if (type === countTypes.CONSIGNMENT && !values.kit) {
      errors.kit = 'Required';
    }

    return errors;
  };

  const list = useMemo(() => {
    let result;

    if (type === countTypes.CONSIGNMENT) {
      const setsList = sets?.filter((set) => !!set.consigned && set?.consignment?.hospital === hospitalId);
      result = kits?.filter((kit) => setsList?.map((s) => s.kit)?.includes(kit.id)) || [];
    }

    return result?.filter((kit) => kit?.name?.toLowerCase()?.includes(search?.toLowerCase()));
  }, [hospitalId, kits, sets, search, type]);

  return (
    <div>
      <Form
        onSubmit={onClickNext}
        validate={validate}
        subscription={{ pristine: true, invalid: true }}
        initialValues={initialValues}
      >
        {
          ({ handleSubmit, submitting, invalid, pristine, form }) => (
            <form onSubmit={handleSubmit} className='form__body'>
              {type === countTypes?.CONSIGNMENT && (
                <>
                  <div>
                    <Input
                      type='search'
                      placeholder='Search Kits'
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>

                  <div className=''>
                    <Field name='kit'>
                      {({ input, meta }) => (
                        <>
                          <div className='field__title'>Kit</div>
                          <div className='m-b-lg form__select-users' style={{ maxHeight: 250 }}>
                            {list?.length ? (
                              list?.map((kit) => (
                                <div className='md-user-info' key={kit.id}>
                                  <Checkbox
                                    input={{
                                      onClick: () => input.onChange(kit.id),
                                      checked: kit.id === input.value
                                    }}
                                    fontSize='small'
                                    label={kit.name}
                                  />
                                </div>
                              ))
                            ) : (
                              <div className='text-center secondary p-md'>
                                No kits
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </Field>
                  </div>
                </>
              )}

              <div className=''>
                <div className='field__title'>Count Name</div>
                <Field name='name'>
                  {(props) => (
                    <Input
                      name={props.input.name}
                      value={props.input.value}
                      placeholder='Type a count name here'
                      type='text'
                      onChange={props.input.onChange}
                    />
                  )}
                </Field>
              </div>

              <div className='m-b-lg'>
                <div className='field__title'>Due Date</div>
                <Field name='dueDate'>
                  {({ input, meta }) => (
                    <DatePicker
                      name={input.name}
                      date={input.value}
                      onDateChange={input.onChange}
                      disablePast
                    />
                  )}
                </Field>
              </div>


              <div className='form__actions'>
                <Button
                  type='submit'
                  text='Continue'
                  disabled={invalid || loading}
                  loading={loading}
                  onClick={handleSubmit}
                />
                <Button
                  type='cancel'
                  onClick={onClickBack}
                  text='Back'
                />
              </div>
            </form>
          )}
      </Form>
    </div>
  );
};

export default Step2;
